import React from 'react';

export default function DropdownForm({
  label,
  input,
  spam,
  cols,
  name,
  register,
  errors,
  options,
  value,
  onChange,
  disabled,
}) {

  return (
    <div
      className={`flex flex-col text-start w-full cols  cols-${!cols || cols === 1 ? '1' : cols
        }`}
    >
      <label className="text-sm flex items-center m-1 font-semibold">
        <p>{label}</p>
        {spam === true && <span className="text-red-500">*</span>}
      </label>
      <select className={`${input} ${input === 'file-input' ? 'file-input-sm file-input-info file-input-bordered'
        : 'input-sm'} outline-none input-bordered focus:outline-none focus:ring-1 rounded-sm `}
        name={name}
        value={value}
        {...register}
        onChange={onChange ? onChange : null}
        disabled={disabled}
      >
        <option></option>
        {options?.map((option, index) => (
          <option key={index} value={option.id}>{option.name}</option>
        ))}
      </select>
      {errors}
    </div>
  );
}
